// axios
import axios from 'axios'

const baseURL = 'https://us-central1-social-test-146aa.cloudfunctions.net/api'

export default axios.create({
  baseURL
  // You can add your headers here
})
